// definition file for the span-util.js browser file
const arrayUtil = require('./src/array-util');
const dateUtil = require('./src/date-util');
const objectUtil = require('./src/object-util');
const objectComparisonUtil = require('./src/object-comparison-util');
const ruleUtil = require('./src/rule-util');
const stringUtil = require('./src/string-util');
const textSearcher = require('./src/text-searcher');
const uuidUtil = require('./src/uuid-util');

var SpanClient = window.SpanClient || {};

SpanClient.DateUtil = SpanClient.DateUtil || dateUtil;
SpanClient.ObjectUtil = SpanClient.ObjectUtil || { ...objectUtil, ...objectComparisonUtil };
SpanClient.RuleUtil = SpanClient.RuleUtil || ruleUtil;
SpanClient.SetUtil = SpanClient.SetUtil || arrayUtil;
SpanClient.StringUtil = SpanClient.StringUtil || stringUtil;
SpanClient.TextSearcher = SpanClient.TextSearcher || textSearcher;
SpanClient.UUID = SpanClient.UUID || uuidUtil;

window.SpanClient = SpanClient;

module.exports = {};
